import dayjs from 'dayjs'
import { User, Calendar, Clock, Zap, CreditCard, XCircle, RotateCw, Minus } from 'react-feather'
import { t } from '@lingui/core/macro'
import { Trans } from '@lingui/react/macro'

import { ConsultationStatus, GetMyInfosQuery } from '@/core/graphql/types'

type ConsultationInfoProps = {
  consultation: GetMyInfosQuery['myInfos']['consultations'][number]
}

function CanBeCanceled(status: ConsultationStatus) {
  switch (status) {
    // case 'Scheduled':
    case 'Accepted':
    case 'Active':
    case 'Completed':
    case 'Canceled':
      return false
    default:
      return true
  }
}

export function ConsultationInfo({ consultation }: ConsultationInfoProps) {
  return (
    <section className="flex flex-col gap-2 w-full">
      <h3 className="section-title">
        <Trans>Consultation</Trans>
      </h3>
      <div className="shadow bg-white pb-4 gap-4 flex flex-col rounded-lg">
        <div className="px-4 py-5 sm:px-6 border-b border-b-gray-100">
          <div className="grid grid-cols-1 gap-x-4 gap-y-3 sm:grid-cols-2">
            <div className="col-span-1">
              <div className="flex flex-row gap-2 items-center">
                <User className="text-gray-500" size={17} />
                <p className="text-md font-medium text-gray-500 capitalize">
                  <Trans>Doctor</Trans>
                </p>
              </div>

              <p className="mt-1 ml-6 text-md font-medium text-gray-900 capitalize truncate">
                {consultation.medecin ? `Dr. ${consultation.medecin.userInfo.surname} ${consultation.medecin.userInfo.name}` : <Minus className="text-md" />}
              </p>
            </div>
            <div className="col-span-1">
              <div className="flex flex-row gap-2 items-center">
                <User className="text-gray-500" size={17} />
                <p className="text-md font-medium text-gray-500">
                  <Trans>Created by</Trans>
                </p>
              </div>
              <p className="mt-1 ml-6 text-md font-medium text-gray-900 capitalize truncate">
                {consultation.createdBy ? (
                  `Dr. ${consultation.createdBy.userInfo.surname} ${consultation.createdBy.userInfo.name}`
                ) : (
                  <Minus className="text-md" />
                )}
              </p>
            </div>
            <div className="col-span-1">
              <div className="flex flex-row gap-2 items-center">
                <Calendar className="text-gray-500" size={17} />
                <p className="text-md font-medium text-gray-500">
                  <Trans>Date</Trans>
                </p>
              </div>
              <p className="mt-1 ml-6 text-md font-medium text-gray-900 capitalize">
                {`${dayjs(consultation.startDate).format('dddd')}
                  ${dayjs(consultation.startDate).format('D')}
                  ${dayjs(consultation.startDate).format('MMM')}
                  ${dayjs(consultation.startDate).format('YYYY')}`}
              </p>
            </div>
            <div className="col-span-1">
              <div className="flex flex-row gap-2 items-center">
                <Clock className="text-gray-500" size={17} />
                <p className="text-md font-medium text-gray-500 capitalize">
                  <Trans>Time</Trans>
                </p>
              </div>
              <p className="mt-1 ml-6 text-md font-medium text-gray-900 capitalize">{dayjs(consultation.startDate).format('HH[h]MM')}</p>
            </div>
            <div className="col-span-1">
              <div className="flex flex-row gap-2 items-center">
                <Zap className="text-gray-500" size={17} />
                <p className="text-md font-medium text-gray-500 capitalize">
                  <Trans>Status</Trans>
                </p>
              </div>
              <p className="mt-1 ml-6 text-md font-medium text-gray-900 capitalize">{consultation.status}</p>
            </div>
            <div className="col-span-1">
              <div className="flex flex-row gap-2 items-center">
                <CreditCard className="text-gray-500" size={17} />
                <p className="text-md font-medium text-gray-500 capitalize">
                  <Trans>Paid</Trans>
                </p>
              </div>
              <p className="mt-1 ml-6 text-md font-medium text-gray-900 capitalize">{consultation.paid ? t`Yes` : t`No`}</p>
            </div>
          </div>
        </div>
        {CanBeCanceled(consultation.status) && (
          <div className="actions gap-5 flex flex-row px-5">
            <div className="h-full w-1/2 flex flex-row justify-center">
              <button
                hidden={consultation.status === 'Canceled'}
                className="flex flex-row justify-center items-center gap-2 w-full sm:w-3/4 md:w-1/2 bg-transparent border border-red-400 py-2 px-4 rounded-full"
              >
                <p className="text-md  text-red-400 font-bold capitalize">
                  <Trans>Cancel</Trans>
                </p>
                <XCircle className="text-md  text-red-400 font-bold" size={17} />
              </button>
            </div>
            <div className="h-full w-1/2 flex flex-row justify-center">
              <button
                hidden={consultation.status === 'Completed'}
                className="flex flex-row justify-center items-center gap-2 w-full sm:w-3/4 md:w-1/2 bg-blue-500 hover:bg-blue-700 py-2 px-4 rounded-full"
              >
                <p className="text-md  text-white font-bold capitalize">
                  <Trans>Reschedule</Trans>
                </p>
                <RotateCw className="text-md  text-white font-bold" size={17} />
              </button>
            </div>
          </div>
        )}
      </div>
    </section>
  )
}
